import React from "react";
import { store } from "@store";
import { CustomerContractsSearch } from "./CustomerContractsSearch/CustomerContractsSearch";
import { CUSTOMER_CONTRACT_SLIDER } from "@navigation";
import { CustomerContractProfileLocation } from "./locations/CustomerContractProfileLocation";
import { CreateCustomerContractLocation } from "./locations/CreateCustomerContractLocation";

export function CustomerContractsPage() {
  const { navigation } = store();

  return (
    <CustomerContractsSearch
      onOpen={(id) =>
        navigation.open(CUSTOMER_CONTRACT_SLIDER, new CustomerContractProfileLocation(id))
      }
      onNew={() =>
        navigation.open(CUSTOMER_CONTRACT_SLIDER, new CreateCustomerContractLocation())
      }
    />
  );
}

export default CustomerContractsPage;
